import { Add as AddIcon, MoreVert as MoreVertIcon } from '@mui/icons-material';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Chip,
  IconButton,
  alpha,
  Card,
  CardHeader,
  CardContent,
} from '@mui/material';
import React from 'react';

import { format, parseISO, isToday, isYesterday } from 'date-fns';

// Mock data - replace with actual data from your API
const mockTasks = [
  {
    id: 'task1',
    title: 'File Complaint',
    description: 'Prepare and file complaint with the court',
    dueDate: '2024-03-15T17:00:00Z',
    priority: 'high',
    status: 'in_progress',
  },
  {
    id: 'task2',
    title: 'Request Medical Records',
    description: 'Send request for medical records',
    dueDate: '2024-03-20T17:00:00Z',
    priority: 'medium',
    status: 'not_started',
  },
  {
    id: 'task3',
    title: 'Prepare Settlement Demand',
    description: 'Draft settlement demand letter',
    dueDate: '2024-03-25T17:00:00Z',
    priority: 'high',
    status: 'not_started',
  },
];

const TasksWidget: React.FC = () => {
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'high':
        return '#f44336'; // Red
      case 'medium':
        return '#ff9800'; // Orange
      case 'low':
        return '#2196f3'; // Blue
      default:
        return '#757575'; // Grey
    }
  };

  const formatDueDate = (dateString: string) => {
    const date = parseISO(dateString);
    if (isToday(date)) {
      return 'Today';
    } else if (isYesterday(date)) {
      return 'Yesterday';
    }
    return format(date, 'MMM d, yyyy');
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader
        title="Tasks"
        action={
          <IconButton size="small">
            <AddIcon fontSize="small" />
          </IconButton>
        }
      />
      <CardContent sx={{ p: 0 }}>
        <List sx={{ flexGrow: 1, overflow: 'auto', p: 0 }}>
          {mockTasks.map(task => (
            <ListItem
              key={task.id}
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                '&:last-child': {
                  borderBottom: 0,
                },
              }}
            >
              <ListItemIcon>
                <Checkbox edge="start" checked={task.status === 'completed'} onChange={() => {}} />
              </ListItemIcon>
              <ListItemText
                primary={task.title}
                secondary={
                  <Box
                    component="div"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mt: 0.5,
                    }}
                  >
                    <Chip
                      label={task.priority}
                      size="small"
                      sx={{
                        height: 20,
                        fontSize: '0.625rem',
                        bgcolor: alpha(getPriorityColor(task.priority), 0.1),
                        color: getPriorityColor(task.priority),
                      }}
                    />
                    <Typography variant="caption" color="text.secondary">
                      Due {formatDueDate(task.dueDate)}
                    </Typography>
                  </Box>
                }
              />
              <IconButton size="small">
                <MoreVertIcon />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default TasksWidget;
